import { Card, CardBody, CardHeader } from '@change/ds-core-ui/Card';
import { ImagePlaceholder } from '@change/ds-core-ui/Image';
import { Text } from '@change/ds-core-ui/Text';

import { stripHtmlTags } from '@change-corgi/core/html';

import type { PetitionShareSlideUpHeaderProps } from '../types';

export const PetitionShareSlidePetitionCard: React.FC<PetitionShareSlideUpHeaderProps> = ({ petition }) => {
	return (
		<div className="text-typography-strong">
			<Card orientation="horizontal" reverse className="grid-cols-[5fr_7fr]">
				<CardHeader variant="media">
					{petition.photo ? (
						<img
							alt="petition"
							className="group-orientation-vertical/Card:h-40 group-orientation-horizontal/Card:w-40 h-full max-w-full object-cover"
							src={petition.photo}
						/>
					) : (
						<ImagePlaceholder className="group-orientation-vertical/Card:h-40 group-orientation-horizontal/Card:w-40 h-full max-w-full" />
					)}
				</CardHeader>

				<CardBody className="min-w-0 py-4">
					<Text as="p" size="medium" fontWeight="bold" className="line-clamp-1 max-h-12 text-ellipsis">
						{petition.ask}
					</Text>

					<Text as="p" size="small" className="text-typography-weak line-clamp-1 max-h-6 text-ellipsis">
						{stripHtmlTags(petition.description)}
					</Text>
				</CardBody>
			</Card>
		</div>
	);
};
